



















































import { ScreenText } from '@/lang/ScreenText';
import { Component, Ref, Vue } from 'vue-property-decorator';
import Datepicker from 'vuejs-datepicker';
import catalogStore from '@/store/modules/catalog/module';

const DATE_FORMAT = 'MM/dd/yyyy';

@Component({
  components: {
    Datepicker,
  }
})
export default class DateRangeFilter extends Vue {
  public readonly screenText = new ScreenText;
  public dateFrom: Date | null = null;
  public dateTo: Date | null = null;
  @Ref('myStartDatePicker') startDatePicker!: any;
  @Ref('myEndDatePicker') endDatePicker!: any;

  get dateFormat(): string {
    return DATE_FORMAT;
  }

  get dateRangeFilterTitle(): string {
    return this.screenText.getScreenText('CATALOG_FILTER_DATE_RANGE');
  }

  get dateRangeFromText(): string {
    return this.screenText.getScreenText('CATALOG_FILTER_DATE_RANGE_FROM');
  }

  get dateRangeToText(): string {
    return this.screenText.getScreenText('CATALOG_FILTER_DATE_RANGE_TO');
  }

  get dateInputPlaceholderText(): string {
    return this.screenText.getScreenText('CATALOG_FILTER_DATE_RANGE_PLACEHOLDER');
  }

  get isLoadingSessions(): boolean {
    return catalogStore.isLoadingSessions;
  }

  updateDateFilters($event: any, type: string) {
    const fullDate: Date | null = $event
      ? new Date($event)
      : null;
    this.$emit('dateFilterChanged', fullDate, type);
  }

  resetFilters() {
    this.startDatePicker.clearDate();
    this.endDatePicker.clearDate();
  }

}
